import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('ABS');
